import { useAPIRequest } from '~/composables/api/useAPIRequest'
import type { ReferenceDetailResponse } from '~/types/api/ReferenceDetail'

export async function useReferencesDetail(referenceId: number | string) {
  return (await useAPIRequest(
    `/reference-landing-pages/detail/${referenceId}`
  )) as ReferenceDetailResponse
}
